import React from 'react'
import View from './view'

const BookingDetailPublic = ({ ...props }) => {

    return <View {...props} />
}

export default BookingDetailPublic
